import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    taxId,
    conpanyName,
    releaseDate,
    representative,
    conpanytaxId,
    taxCalculationPeriod,
    userName,
    where,
  },
} = checkout;

const validation = Yup.object().shape({
  [conpanyName.name]: Yup.string().required(conpanyName.errorMsg),
  [taxCalculationPeriod.name]: Yup.string().required(taxCalculationPeriod.errorMsg),
  [userName.name]: Yup.string().required(userName.errorMsg),
  [where.name]: Yup.string().required(where.errorMsg),
  [releaseDate.name]: Yup.string().required(releaseDate.errorMsg),
  [representative.name]: Yup.string().required(representative.errorMsg),
  [taxId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId.invalidMsg)
    .required(taxId.errorMsg),
  [conpanytaxId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId.invalidMsg)
    .required(taxId.errorMsg),
});

export default validation;
